module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/codebook-icon-right.8fc2db5c.png";